<template>
  <div class="article bg-grey">
    <div class="bg-white" style="padding-bottom: 75px">
      <div class="middle-main flex-row article-box">
        <div class="article-con">
          <h1>{{ detailsRes.newsTitle }}</h1>
          <div class="other-info justify-between items-center">
            <div class="items-center">
              <div class="items-center" v-if="detailsRes.author">
                <span>{{ detailsRes.author }}</span>
              </div>
              {{ detailsRes.linkMagazine ? ' · ' + detailsRes.linkMagazine : '' }}
              <div class="items-center" v-if="detailsRes.linkMagazine">
                {{ detailsRes.linkMagazine ? L('摘自' + detailsRes.linkMagazine) : '' }}
              </div>
            </div>
            <div class="items-center">
              <share style="opacity: 0;" :detailsRes="detailsRes"></share>
            </div>
          </div>

          <!-- 作者信息（PC） -->
          <div v-if="isPc === 3 && detailsRes.author" class="author-info flex-row">
            <div class="flex-row items-center">
              <img :src="detailsRes.authorAvatar || require('@/assets/images/default-avatar.png')" />
              <h3>{{ detailsRes.author }}</h3>
            </div>
            <button @click="toAuthorDetails" v-if="detailsRes.authorId">
              <svg-icon icon-class="arrow-right" />
            </button>
          </div>

          <div class="details" v-html="detailsRes.newsContent"></div>

          <!-- 标签 -->
          <div class="tags items-center" v-if="detailsRes.tag && detailsRes.tag.length">
            <span v-for="item in detailsRes.tag" :key="item" @click="getTagNews(item)">{{ item }}</span>
          </div>

          <Comment :newsId="detailsRes.newsId" :type="1" />
          <RelatedArticle v-if="detailsRes.typeId === 20" :author="detailsRes.newsTitle" />
        </div>

        <div class="relate-news">
          <!-- 作者信息（移动） -->
          <div class="author-info flex-col" v-if="detailsRes.author && isPc !== 3">
            <img :src="detailsRes.authorAvatar || require('@/assets/images/default-avatar.png')" />
            <h3>{{ detailsRes.author }}</h3>
            <button @click="toAuthorDetails" v-if="detailsRes.authorId">
              更多文章 <svg-icon icon-class="arrow-right" />
            </button>
          </div>

          <div class="news-list">
            <h3>
              你可能喜欢
              <span class="change">
                <svg-icon icon-class="change" />
                <span @click="changeHotNews">换一批</span>
              </span>
            </h3>
            <div class="like-list">
              <div v-for="item in newsListRes" :key="item.newsId">
                <NewsItem :item="item" direction="col" imgSize="middle2" />
                <div class="line"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { getNewsDetails, getNewsList } from '@/assets/api/news.js';
import RelatedArticle from './components/related-article.vue';
import NewsItem from '../common/news-item.vue';
import Comment from '../common/comment.vue';
import share from '../share/index.vue';

export default {
  components: {
    NewsItem,
    RelatedArticle,
    Comment,
    share
  },
  data() {
    return {
      detailsRes: {},
      newsListRes: [],
      allNewsListRes: [],
      keyword: ''
    };
  },
  metaInfo() {
    return {
      title: this.detailsRes.newsTitle,
      meta: [
        { name: 'keywords', content: this.detailsRes.tag ? this.detailsRes.tag.join(',') : '' },
        { name: 'description', content: this.cleanText(this.detailsRes.newsContent).substring(0, 200) + '...' },
        { property: 'og:title', content: this.detailsRes.newsTitle },
        { property: 'og:description', content: this.cleanText(this.detailsRes.newsContent).substring(0, 200) + '...' },
        { property: 'og:image', content: this.resolveImageUrl(this.detailsRes.newsImage) },
        { property: 'og:url', content: typeof window !== 'undefined' ? `https://ts960.com/${this.detailsRes.seoUrl ? this.detailsRes.seoUrl : this.detailsRes.newsId}.html` : '' },
        { property: 'og:type', content: 'article' }
      ]
    };
  },
  computed: {
    ...mapState(['isPc'])
  },
  watch: {
    '$route.params.slug': {
      handler(newSlug) {
        this.fetchDetails(newSlug);
      },
      immediate: true
    }
  },
  mounted() {
    if (typeof FB !== 'undefined' && !window.fbInitialized) {
      FB.init({
        appId: '1951935595172355',
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v16.0'
      });
      window.fbInitialized = true;
    }


  },
  methods: {
    ...mapActions(['setSearchKeyword', 'triggerSearch']),
    updateMetaTags(data) {
      document.title = data.newsTitle || '《台商》雜 誌';
      let path = data.seoUrl ? data.seoUrl : data.newsId

      const cleanText = this.cleanText(data.newsContent).substring(0, 200) + '...';
      const tags = [
        { property: 'og:title', content: data.newsTitle },
        { property: 'og:description', content: cleanText },
        { property: 'og:image', content: this.resolveImageUrl(data.newsImage) },
        { property: 'og:url', content: typeof window !== 'undefined' ? `https://ts960.com/${path}.html` : '' },
        { property: 'og:type', content: 'article' }
      ];

      tags.forEach(({ property, content }) => {
        let tag = document.querySelector(`meta[property="${property}"]`);
        if (!tag) {
          tag = document.createElement('meta');
          tag.setAttribute('property', property);
          document.head.appendChild(tag);
        }
        tag.setAttribute('content', content);
      });
    },

    async fetchDetails(slug = this.$route.params.slug) {
      const idOrSlug = isNaN(slug) ? 'seoUrl/' + slug : slug;
      const res = await getNewsDetails(idOrSlug);
      const data = res.data.data;
      this.detailsRes = {
        ...data,
        author: data.authorV2 || data.author,
        authorAvatar: this.resolveImageUrl(data.authorAvatarV2 || data.authorAvatar),
        tag: data.tag ? data.tag.split('|') : []
      };
      // ✅ 插入 meta
      this.updateMetaTags(data);

      this.$nextTick(() => {
        this.$nextTick(() => {
          if (this.detailsRes.newsTitle) {
            console.log('✅ render-event dispatched AFTER meta injected manually');
            document.dispatchEvent(new Event('render-event'));
          }
        });
      });


      if (data.newsId) {
        getNewsList({
          orderByColumn: 'releaseTime',
          isAsc: 'desc',
          newsId: data.newsId,
          pageNum: 1,
          pageSize: 50,
          slideshow: 0
        }).then(res => {
          this.allNewsListRes = res.data.rows;
          this.changeHotNews();
        })
      }

    },

    changeHotNews() {
      this.newsListRes = this.allNewsListRes
        .sort(() => Math.random() - 0.5)
        .slice(0, 4)
        .map(item => ({
          ...item,
          newsImage: this.resolveImageUrl(item.newsImage),
          tag: item.tag ? item.tag.split('|').join(' · ') : ''
        }));
    },

    getTagNews(name) {
      this.keyword = '#' + name;
      this.setSearchKeyword(this.keyword);
      this.triggerSearch();
    },

    toAuthorDetails() {
      this.$router.push({ path: `/expert-details/${this.detailsRes.authorId}` });
    },

    resolveImageUrl(url) {
      return url && !/^http/.test(url) ? this.$imgUrl + url : url || '';
    },

    cleanText(html) {
      return html ? html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim() : '';
    }
  }
};
</script>

<style lang="less" scoped>
.article {
  margin-top: 30px;
}

.article-con {
  flex: 1;

  .banner1 {
    width: 100%;
    height: 240px;
    object-fit: cover;
  }

  h1 {
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 40px;
    color: #2C2C2E;
    line-height: 52px;
    text-align: left;
    font-style: normal;
    padding: 40px 0 16px;
  }

  .other-info {
    margin-bottom: 40px;

    span {
      font-family: MicrosoftYaHei;
      font-size: 14px;
      color: #636366;
      line-height: 19px;
      text-align: left;
      font-style: normal;
    }

    .share-buttons {
      display: flex;
      align-items: center;
      gap: 10px;

      .share-btn {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 8px 16px;
        border: 1px solid #E5E5EA;
        border-radius: 20px;
        background: #FFFFFF;
        cursor: pointer;
        transition: all 0.3s ease;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #2C2C2E;

        .svg-icon {
          width: 16px;
          height: 16px;
        }

        &:hover {
          border-color: #0666FF;
          color: #0666FF;
          transform: translateY(-1px);
          box-shadow: 0 2px 8px rgba(6, 102, 255, 0.2);
        }

        &.facebook-share {
          &:hover {
            border-color: #1877F2;
            color: #1877F2;
            box-shadow: 0 2px 8px rgba(24, 119, 242, 0.2);
          }
        }
      }
    }
  }

  .details {
    line-height: 2.19;
    letter-spacing: 0.8px;
    color: #000;
  }

  .tags {
    margin-top: 80px;
    border-top: 1px solid #E5E5EA;
    padding-top: 30px;

    span {
      font-family: MicrosoftYaHei;
      font-size: 16px;
      color: #2C2C2E;
      line-height: 21px;
      text-align: center;
      font-style: normal;
      background: #FFFFFF;
      border-radius: 25px;
      border: 1px solid #E5E5EA;
      padding: 14px 24px;
      margin-right: 8px;
      cursor: pointer;
    }
  }

  .other-news {
    width: 100%;

    .swiper-slide {
      width: 100%;
    }
  }
}

.relate-news {
  width: 320px;
  margin-left: 60px;

  .banner2 {
    width: 100%;
    height: auto;
    object-fit: cover;
  }

  .banner3 {
    width: 100%;
    height: auto;
    object-fit: cover;
  }

  .news-list {
    h3 {
      font-family: MicrosoftYaHei, MicrosoftYaHei;
      font-weight: bold;
      font-size: 32px;
      color: #2C2C2E;
      line-height: 42px;
      text-align: left;
      font-style: normal;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 40px 0 30px;

      span {
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #AEAEB2;
        line-height: 19px;
        text-align: left;
        font-style: normal;
        cursor: pointer;
      }

      .change {
        &:hover {
          span {
            color: #E2291E;
          }

          color: #E2291E;
        }
      }
    }

    h2 {
      font-family: NotoSansCJKTC;
      font-size: 20px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 29px;
      letter-spacing: normal;
      text-align: left;
      color: #222;
      padding: 6px 0;
      margin-top: 15px;
      margin-bottom: 20px;
      border-bottom: 1px solid #e13133;
    }

    .news-item {
      margin-bottom: 10px;

      img {
        width: 100px;
        height: 100px;
        object-fit: cover;
        margin-right: 10px;
      }

      time {
        font-family: NotoSansCJKTC;
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.71;
        letter-spacing: 0.7px;
        text-align: center;
        color: #8b8b8b;
        margin-bottom: 2px;
      }

      h3 {
        font-family: NotoSansCJKTC;
        font-size: 16px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: 2.4px;
        text-align: left;
        color: #222;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }
    }
  }
}

.other-news {
  padding: 40px 0 80px;
}

.like-list {
  .line {
    width: 100%;
    height: 1px;
    background: #E5E5EA;
    margin-bottom: 20px;
    margin-top: 20px;

  }
}

.author-info {
  display: flex;
  align-items: center;
  justify-content: center;
  // flex-direction: column;
  background: #F2F2F7;
  border-radius: 16px;
  width: 100%;
  padding: 60px 20px;

  img {
    width: 100px;
    height: 100px;
    border: 2px solid #E5E5EA;
    border-radius: 50%;
    object-fit: cover;
    margin-bottom: 20px;
  }

  h3 {
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 24px;
    color: #2C2C2E;
    line-height: 31px;
    text-align: center;
    font-style: normal;
  }

  p {
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #AEAEB2;
    line-height: 19px;
    text-align: center;
    font-style: normal;
  }

  button {
    width: 138px;
    height: 50px;
    background: #FFFFFF;
    border-radius: 25px;
    border: 1px solid #E5E5EA;
    margin-top: 20px;
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 16px;
    color: #2C2C2E;
    line-height: 21px;
    text-align: left;
    font-style: normal;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    .svg-icon {
      width: 16px;
      height: 16px;
      margin-left: 10px;
    }

    &:hover {
      border: 2px solid #E2291E;
    }
  }

}

@media screen and (max-width: 768px) {
  .article {
    margin-top: 0;

    .article-con {
      padding: 20px;
      flex: 1;

      .banner1 {
        width: 100%;
        height: auto;
        object-fit: cover;
      }

      h1 {
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 32px;
        color: #2C2C2E;
        line-height: 42px;
        text-align: left;
        font-style: normal;
        padding: 0;
      }

      .other-info {
        padding: 0;
        padding-bottom: 10px;
        // border-bottom: 1px solid #e13133;
        margin: 16px 0;
        font-family: MicrosoftYaHei;
        font-size: 12px;
        color: #2C2C2E;
        line-height: 16px;
        text-align: left;
        font-style: normal;

        div {
          margin-right: 12px;
        }

        .svg-icon {
          width: 16px;
          height: 16px;
          margin-right: 3px;
        }

        .share-buttons {
          margin-top: 10px;

          .share-btn {
            padding: 6px 12px;
            font-size: 12px;

            .svg-icon {
              width: 14px;
              height: 14px;
            }
          }
        }
      }

      .details {
        font-family: MicrosoftYaHei;
        font-size: 16px;
        color: #2C2C2E;
        line-height: 24px;
        text-align: justify;
        font-style: normal;
      }

      .tags {
        margin: 40px 0 0;
        padding-top: 20px;

        span {
          padding: 9px 20px;
          font-family: MicrosoftYaHei;
          font-size: 14px;
          color: #2C2C2E;
          line-height: 19px;
          text-align: center;
          font-style: normal;
        }
      }

      .other-news {
        width: 100%;

        .swiper-slide {
          width: 100%;
        }
      }
    }

  }

  .article-box {
    flex-direction: column;
  }

  .relate-news {
    width: 100%;
    margin-left: 0;
    padding: 0 20px;

    .banner2 {
      width: 100%;
      height: auto;
      object-fit: cover;
    }

    .banner3 {
      width: 100%;
      height: auto;
      object-fit: cover;
    }

    .news-list {
      h3 {
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 24px;
        color: #2C2C2E;
        line-height: 31px;
        text-align: left;
        font-style: normal;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 20px 0 10px;

        span {
          font-family: MicrosoftYaHei;
          font-size: 12px;
          color: #AEAEB2;
          line-height: 16px;
          text-align: left;
          font-style: normal;
          display: flex;
          align-items: center;

          .svg-icon {
            width: 11px;
            height: 11px;
            margin-right: 5px;
          }
        }

        .change {
          &:hover {
            span {
              color: #E2291E;
            }

            color: #E2291E;
          }
        }
      }

      h2 {
        font-family: NotoSansCJKTC;
        font-size: 20px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 29px;
        letter-spacing: normal;
        text-align: left;
        color: #222;
        padding: 6px 0;
        margin-top: 15px;
        margin-bottom: 20px;
        border-bottom: 1px solid #e13133;
      }

      .news-item {
        margin-bottom: 10px;

        img {
          width: 100px;
          height: 100px;
          object-fit: cover;
          margin-right: 10px;
        }

        time {
          font-family: NotoSansCJKTC;
          font-size: 14px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.71;
          letter-spacing: 0.7px;
          text-align: center;
          color: #8b8b8b;
          margin-bottom: 2px;
        }

        h3 {
          font-family: NotoSansCJKTC;
          font-size: 16px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.5;
          letter-spacing: 2.4px;
          text-align: left;
          color: #222;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          word-break: break-all;
        }
      }
    }
  }

  .author-info {
    padding: 20px;
    justify-content: space-between;
    margin-bottom: 30px;

    img {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      object-fit: cover;
      margin-right: 10px;
      margin-bottom: 0;
    }

    h3 {
      font-size: 16px;
      color: #2C2C2E;
      line-height: 21px;
      text-align: left;
      font-style: normal;
    }

    button {
      width: 40px;
      height: 40px;
      background: #FFFFFF;
      border-radius: 25px;
      border: 1px solid #E5E5EA;
      margin-top: 0;

      .svg-icon {
        margin-left: 0;
      }
    }
  }
}
</style>
<style>
.details img {
  display: block;
  max-width: 90%;
  height: auto;
  margin: 35px auto;
}

.details video {
  width: 100%;
  height: auto;
  border-radius: 8px;
}

.details iframe {
  width: 100%;
  height: 500px;
  max-width: 100%;
}

@media screen and (max-width: 768px) {
  .details img {
    max-width: 100%;
    margin: 15px auto;
  }

  .details iframe {
    width: 100%;
    height: 300px;
    max-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/article-details/index.vue